<template>
    <div class="container">
        <div class="col-sm-3 col-xs-2"></div>
        <div class="col-sm-6 col-xs-8">
            <div class="row">
                <div class="col-sm-3 col-xs-0"></div>
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group has-feedback has-feedback-left">
                        <input type="text" class="form-control" v-model="username" name="loginUsername" placeholder="Username"  />
                        <i class="form-control-feedback glyphicon glyphicon-user"></i>
                    </div>
                </div>
                <div class="col-sm-3 col-xs-0"></div>
            </div>
            <br>
            <div class="row">
                <div class="col-sm-3 col-xs-0"></div>
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group has-feedback">
                        <input type="password" class="form-control" placeholder="Password" v-model="password" name="loginPassword" @keyup.enter="login" />
                        <i class="form-control-feedback fa fa-lock" style="font-size: 20px;top: 7px;"></i>
                    </div>
                </div>
                <div class="col-sm-3 col-xs-0"></div>
            </div>
            <br>
            <div class="row">
                <div class="col-xs-12"><button class="btn btn-primary" @click="login">Login</button></div>
            </div>
        </div>
        <div class="col-sm-3 col-xs-2"></div>
    </div>
</template>

<script>
    import swal from 'sweetalert2'
    import axios from 'axios'

    export default {
      name: 'login-page',
      data () {
        return {
          username: '',
          password: ''
        }
      },
      methods: {
        login () {
          let errorMessage = ''
          if (this.username === undefined || this.username.trim() === '') {
            errorMessage += 'Username is invalid\n'
          }
          if (this.password === undefined || this.password.trim() === '') {
            errorMessage += 'Password is invalid\n'
          }
          if (errorMessage !== '') {
            swal('Please fix the following: \n' + errorMessage)
          } else {
            axios.post('./static/api/Ajax.php', {
              Username: this.username,
              Password: this.password,
              action: 'Login'
            }).then((response) => {
              if (response.data.status === 'success') {
                this.$store.dispatch('setUserName', response.data.username)
                this.$store.dispatch('setUserStatus', response.data.userStatus)
                  axios.post('./static/api/Ajax.php', {
                      action: 'Get User Type'
                  }).then((response) => {
                      this.$store.commit('userType', response.data.userType);
                      //alert(JSON.parse(response).userType);
                  }).catch((e) => {
                      console.log(e)
                  });
                window.location = './#/search'
              } else if (response.data.status) {
                swal(response.data.status)
              }
            }).catch((e) => {
              console.log(e)
            })
          }
        }
      },
      mounted () {
        axios.post('./static/api/Ajax.php', {
          action: 'Logout'
        })
      }
    }
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/loginPage.vue